import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Payment Images Cell Renderer
 * Muestra un ícono con badge indicando la cantidad de imágenes de pago
 */
@Component({
  selector: 'app-payment-images-cell-renderer',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatBadgeModule, MatTooltipModule],
  template: `
    <mat-icon
      color="primary"
      [matBadge]="imageCount"
      [matTooltip]="imageCount > 0 ? 'Ver imágenes' : 'Sin imágenes'"
      class="pointer-icon"
      (click)="onImageClick()"
      matBadgeColor="accent"
      matBadgeSize="small"
      aria-hidden="false">
      photo_library
    </mat-icon>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
    .pointer-icon {
      cursor: pointer;
    }
  `]
})
export class PaymentImagesCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any, any>;

  get imageCount(): number {
    return this.params?.data?.paymentImages?.length || 0;
  }

  onImageClick(): void {
    if (this.imageCount > 0 && this.params?.onImageClick) {
      this.params.onImageClick(this.params.data);
    }
  }
}
